import { render } from "./ManageKnowledgeDocumentsPage.vue?vue&type=template&id=3801d1ca&scoped=true"
import script from "./ManageKnowledgeDocumentsPage.vue?vue&type=script&lang=js"
export * from "./ManageKnowledgeDocumentsPage.vue?vue&type=script&lang=js"

import "./ManageKnowledgeDocumentsPage.vue?vue&type=style&index=0&id=3801d1ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3801d1ca"]])

export default __exports__